<template>
  <div>
    <main class="main configurations">
      <div class="white-panel">
        <header class="panel-header space-between">
          <div>
            <router-link
              :to="{name: 'AdminPage'}"
              type="button"
              class="step-back"
              :aria-label="$t('step.back')"
              :title="$t('step.back')"
            />
            <h2 class="panel-title">
              {{ $t('all.services') }}
            </h2>
          </div>
          <button
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
            class="btn-primary btn-active btn-add l-auto link-modal"
            @click="openAddServiceModal()"
          >
            {{ $t('service.create') }}
          </button>
        </header>

        <div class="config-panel panel-scroll">
          <div
            v-for="service in services"
            :key="service.id"
            class="row space-between"
          >
            <div>
              <div class="config-label">
                {{ service.title[$i18n.locale()] }}
              </div>
              <div class="config-description">
                {{ service.id }}
              </div>
            </div>
            <dropdown :size="'sm'">
              <button
                slot="dropdown-trigger"
                type="button"
                class="btn-more-actions btn-tooltip"
                aria-haspopup="true"
                aria-expanded="false"
                :data-tooltip="$t('more.actions')"
                :aria-label="$t('more.actions')"
                :title="$t('more.actions')"
              />

              <div slot="dropdown-panel">
                <ul class="dropdown-menu">
                  <li
                    class="dropdown-menu__item"
                  >
                    <button
                      class="dropdown-menu__link"
                      @click="openEditServiceModal(service)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                        >
                          <g
                            fill="#8F95A1"
                            fill-rule="evenodd"
                          >
                            <path
                              fill="none"
                              d="M-4-4h24v24H-4z"
                            />
                            <path
                              fill-rule="nonzero"
                              d="M12.8676109.22550203c-.2898173-.28737753-.7530846-.2939411-1.0477144-.0017916l-1.4674447 1.45509152 3.9517401 3.91847364 1.4674447-1.45509151c.2888194-.28638807.2875888-.75193505-.0018068-1.03889451L12.8676109.22550203zM9.69140709 2.33428192L.82178471 11.1292384 0 16l4.77352474-.952288 8.86962236-8.79495644-3.95174001-3.91847364z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">Editar</span>
                    </button>
                  </li>

                  <li class="dropdown-menu__item">
                    <button
                      class="dropdown-menu__link"
                      @click="openDeleteServiceModal(service)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="17"
                        >
                          <g
                            fill="#8F95A1"
                            fill-rule="evenodd"
                          >
                            <path d="M1.16666667 4.57142857H12.8333333v9.65779223c0 1.2935657-1.0353388 2.3422078-2.3328841 2.3422078H3.49955081c-1.28841633 0-2.33288414-1.0439292-2.33288414-2.3422078V4.57142857z" />
                            <path
                              fill-rule="nonzero"
                              d="M10.0087719 1.73714286v-.56880554C10.0087719.52308243 9.49266564 0 8.84162274 0H5.12255855c-.6445987 0-1.16714919.52078358-1.16714919 1.16918387v.59843518H1.16535983C.52174937 1.76761905 0 2.29315476 0 2.93921445v.48935698h14v-.51667502c0-.64879847-.5217834-1.17475355-1.1759129-1.17475355h-2.8153152z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">{{ $t('erase') }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dropdown>
          </div>
        </div>
      </div>
    </main>
    <modal v-model="editServiceModal">
      <edit-service
        slot="modal-panel"
        v-model="editServiceModal"
        :service="workingService"
      />
    </modal>
    <modal v-model="deleteServiceModal">
      <delete-service
        slot="modal-panel"
        v-model="deleteServiceModal"
        :service="workingService"
      />
    </modal>
    <modal v-model="addServiceModal">
      <add-service
        slot="modal-panel"
        v-model="addServiceModal"
      />
    </modal>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import EditService from '@/components/modals/EditService'
import DeleteService from '@/components/modals/DeleteService'
import AddService from '@/components/modals/AddService'
import Dropdown from '@/components/utils/Dropdown'

import Modal from '@/components/utils/Modal'

export default {
  components: {
    Dropdown,
    Modal,
    AddService,
    DeleteService,
    EditService
  },
  props: {
    serviceID: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      editServiceModal: false,
      deleteServiceModal: false,
      addServiceModal: false,
      workingService: undefined
    }
  },
  computed: {
    ...mapState(['services']),
    displayDevices (type) {
      return this.devices.concat([]).filter(device => device.type === 'display')
    },
    kioskDevices (type) {
      return this.devices.concat([]).filter(device => device.type === 'kiosk')
    }
  },
  async created () {
    await this.fetchServices()
  },
  methods: {
    ...mapActions(['fetchServices']),
    openAddServiceModal () {
      this.addServiceModal = true
    },
    openEditServiceModal (service) {
      this.workingService = service
      this.editServiceModal = true
    },
    openDeleteServiceModal (service) {
      this.workingService = service
      this.deleteServiceModal = true
    }
  }
}
</script>
<style lang="scss">
.device-state-configs {
  margin-right: 5rem;
}

.button-dropdown {
  position: relative;
}

.btn-edit,
.btn-delete,
.btn-more-actions {
  position: relative;
  width: 3rem;
  height: 3rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
</style>
